let customTranslations = {
  en: {
    information:
      "We apologize for the inconvenience, but please re-register your web account due to the switching of the login authentication system.",
    buttonText: "Re-register your web account",
  },
  aa: {
    information:
      "If you haven't logged in for a long time, you may need to update your username by clicking the button below. ",
    buttonText: "Update Account",
  },
  es: {
    information:
      "Nos disculpamos por las molestias, pero por favor, vuelva a registrar su cuenta web debido a la conmutación del sistema de autenticación de inicio de sesión.",
    buttonText: "Vuelva a registrar su cuenta web",
  },
  fr: {
    information:
      "Si vous n'êtes pas connecté depuis longtemps, vous devrez peut-être mettre à jour votre nom d'utilisateur en cliquant sur le bouton ci-dessous.",
    buttonText: "Compte mis à jour",
  },
  vi: {
    information:
      "Nếu bạn chưa đăng nhập trong một thời gian dài, bạn có thể cần phải cập nhật tên người dùng bằng cách nhấn vào nút bên dưới.",
    buttonText: "Cập nhật tài khoản",
  },
  "pt-BR": {
    information:
      "Se você não tiver conectado por um longo tempo, você pode precisar atualizar seu nome de usuário clicando no botão abaixo.",
    buttonText: "Atualizar conta",
  },
  iw: {
    information:
      "אם עדיין לא מחובר במשך זמן רב, ייתכן שתצטרך לעדכן את שם המשתמש שלך על ידי לחיצה על הכפתור למטה.",
    buttonText: "לעדכן חשבון",
  },
  ru: {
    information:
      "Если вы еще не вошли в течение длительного времени, возможно, потребуется обновить имя пользователя, нажав на кнопку ниже.",
    buttonText: "Счет обновления",
  },
  "nl-NL": {
    information:
      "Als u nog niet bent aangemeld voor een lange tijd, moet u uw gebruikersnaam bijwerken door te klikken op de onderstaande knop.",
    buttonText: "Account bijwerken",
  },
  it: {
    information:
      "Se non si è connesso per un lungo periodo di tempo, potrebbe essere necessario aggiornare il nome utente facendo clic sul pulsante qui sotto.",
    buttonText: "Aggiorna account",
  },
  de: {
    information:
      "Wenn Sie nicht für eine lange Zeit angemeldet haben, müssen Sie Ihren Benutzernamen aktualisieren, indem Sie auf den Button unten klicken.",
    buttonText: "Konto aktualisieren",
  },
  cs: {
    information:
      "Pokud jste se ještě nepřihlásili na dlouhou dobu, možná budete muset aktualizovat své uživatelské jméno klepnutím na tlačítko níže.",
    buttonText: "aktualizace účtu",
  },
  da: {
    information:
      "Hvis du ikke er logget ind i lang tid, kan det være nødvendigt at opdatere dit brugernavn ved at klikke på knappen nedenfor.",
    buttonText: "Opdatering konto",
  },
  fi: {
    information:
      "Jos et ole kirjautunut sisään pitkään aikaan, voit joutua päivittämään käyttäjätunnuksesi napsauttamalla alla olevaa painiketta.",
    buttonText: "Tilin päivitys",
  },
  sv: {
    information:
      "Om du inte har loggat in under en längre tid, kan du behöva uppdatera ditt användarnamn genom att klicka på knappen nedan.",
    buttonText: "Uppdatera konto",
  },
  hu: {
    information:
      "Ha nem vagy bejelentkezve sokáig, előfordulhat, hogy frissítenie kell a felhasználónevét az alábbi gombra kattintva.",
    buttonText: "Fiók frissítése",
  },
  is: {
    information:
      "Ef þú hefur ekki innskráður langan tíma, gætir þú þurft að uppfæra notandanafnið með því að smella á hnappinn hér fyrir neðan.",
    buttonText: "Uppfæra Reikningur",
  },
  no: {
    information:
      "Hvis du ikke har logget inn for en lang tid, må du kanskje oppdatere ditt brukernavn ved å klikke på knappen nedenfor.",
    buttonText: "Oppdater konto",
  },
  th: {
    information:
      "หากคุณยังไม่ได้เข้ามาเป็นเวลานานคุณอาจจำเป็นต้องปรับปรุงชื่อผู้ใช้ของคุณโดยคลิกที่ปุ่มด้านล่าง",
    buttonText: "อัปเดตบัญชี",
  },
  pl: {
    information:
      "Jeśli nie zalogujesz się przez dłuższy czas, może trzeba zaktualizować swoją nazwę użytkownika, klikając przycisk poniżej.",
    buttonText: "Zaktualizuj konto",
  },
  ro: {
    information:
      "Dacă nu v-ați conectat pentru o lungă perioadă de timp, poate fi necesar să actualizați numele de utilizator făcând clic pe butonul de mai jos.",
    buttonText: "Actualizare cont",
  },
  sk: {
    information:
      "Ak ste sa ešte neprihlásili na dlhú dobu, možno budete musieť aktualizovať svoje užívateľské meno kliknutím na tlačidlo nižšie.",
    buttonText: "aktualizácie účtu",
  },
  tr: {
    information:
      "Uzun bir süre için giriş yapmış olmadıysanız, aşağıdaki düğmeyi tıklayarak kullanıcı adınızı güncellemeniz gerekebilir.",
    buttonText: "Hesabı güncelle",
  },
  uk: {
    information:
      "Якщо ви ще не ввійшли в протягом тривалого часу, можливо, буде потрібно оновити ім'я користувача, натиснувши на кнопку нижче.",
    buttonText: "рахунок поновлення",
  },
  in: {
    information:
      "Kami mohon maaf atas ketidaknyamanan ini, tapi tolong mendaftar ulang akun web Anda karena switching dari sistem otentikasi login.",
    buttonText: "Daftar ulang akun web Anda",
  },
  ms: {
    information:
      "Jika anda belum log masuk untuk masa yang lama, anda mungkin perlu untuk mengemas kini nama pengguna anda dengan mengklik butang di bawah.",
    buttonText: "Akaun Update",
  },
  ja: {
    information:
      "ログイン認証システムの切り替えに伴い、お手数ではございますが、ウェブ アカウントの再登録を行ってください。",
    buttonText: "ウェブ アカウントを再登録する",
  },
  "zh-TW": {
    information:
      "如果您還沒有登錄了很長一段時間，你可能需要通過點擊下面的按鈕來更新您的用戶名。",
    buttonText: "更新賬戶",
  },
  "zh-CN": {
    information:
      "如果您还没有登录了很长一段时间，你可能需要通过点击下面的按钮来更新您的用户名。",
    buttonText: "更新账户",
  },
};

export default customTranslations;
